import { Box } from "@mui/material";

const MainBox = ({ children }) => {
  return (
    <Box sx={{
      backgroundColor: 'rgba(60, 0, 255, 0.5)',
      minHeight: '100vh',
      padding: '0 1rem',
      flex: 1,
    }}>
      {children}
    </Box>
  );
}

export default MainBox;